export default "__VITE_ASSET__Bxqautn$__"